import React from 'react';

// https://blog.webdevsimplified.com/2020-07/relative-time-format/
var DIVISIONS = [{
  amount: 60,
  name: 'seconds'
}, {
  amount: 60,
  name: 'minutes'
}, {
  amount: 24,
  name: 'hours'
}, {
  amount: 7,
  name: 'days'
}, {
  amount: 4.34524,
  name: 'weeks'
}, {
  amount: 12,
  name: 'months'
}, {
  amount: Number.POSITIVE_INFINITY,
  name: 'years'
}];
function formatTimeAgo(date, formatter) {
  var duration = (date - new Date()) / 1000;
  for (var i = 0; i < DIVISIONS.length; i++) {
    var division = DIVISIONS[i];
    if (Math.abs(duration) < division.amount) {
      return formatter.format(Math.round(duration), division.name);
    }
    duration /= division.amount;
  }
}
export default function (_ref) {
  var date = _ref.date,
    locale = _ref.locale,
    _ref$localeStyle = _ref.localeStyle,
    localeStyle = _ref$localeStyle === void 0 ? 'long' : _ref$localeStyle,
    _ref$localeNumeric = _ref.localeNumeric,
    localeNumeric = _ref$localeNumeric === void 0 ? 'auto' : _ref$localeNumeric;
  var formatter = new Intl.RelativeTimeFormat(locale, {
    style: localeStyle,
    numeric: localeNumeric
  });
  var text = formatTimeAgo(date, formatter);
  return /*#__PURE__*/React.createElement(React.Fragment, null, text);
}